// extracted by mini-css-extract-plugin
export default {"title":"total_title__NrW+k","total":"total_total__7Z0EG"};